module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "id": "c2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/c001#ref_TOC"
    }
  }, [_vm._v("Kapitel 2")])]), _vm._v(" "), _c('h1', [_vm._v("Kapitel Zwei - Die Fragen, die Sie sich stellen sollten, bevor Sie spielen")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("\"D")]), _vm._v("as Glücksspiel selbst")]), _vm._v(" wird erst dann aufhören, wenn sich die menschliche Natur völlig verändert hat.\"")]), _vm._v(" -Harold S. Smith Sr")]), _vm._v(" "), _c('p', [_vm._v("Bevor Sie spielen, müssen Sie 7 Fragen stellen und beantwortet bekommen.")]), _vm._v(" "), _c('p', [_vm._v("Wenn Sie jemals an einem Journalismus Kurs teilgenommen haben, wissen Sie, dass jeder Reporter zu Beginn jeder Nachricht 6 Fragen beantworten muss.")]), _vm._v(" "), _c('p', [_vm._v("Sie sind als die 5 Ws und H bekannt.")]), _vm._v(" "), _c('p', [_vm._v("Wer?")]), _vm._v(" "), _c('p', [_vm._v("Wie?")]), _vm._v(" "), _c('p', [_vm._v("Wo?")]), _vm._v(" "), _c('p', [_vm._v("Warum?")]), _vm._v(" "), _c('p', [_vm._v("Wann?")]), _vm._v(" "), _c('p', [_vm._v("Wie?")]), _vm._v(" "), _c('p', [_vm._v("Da unser Thema das Glücksspiel ist, füge ich eine 7. wichtige Frage hinzu:")]), _vm._v(" "), _c('p', [_vm._v("Wie viel?")]), _vm._v(" "), _c('p', [_vm._v("Ich werde das \"wer\" nicht weiter erwähnen, denn die Antwort ist offensichtlich. Wer bist du?")]), _vm._v(" "), _c('p', [_vm._v("Sie müssen also anfangen, darüber nachzudenken, wer Sie sind. Das kann ich offensichtlich nicht beantworten. Jeder von Ihnen ist anders, und deshalb wird auch das, was dieses Buch für Sie tut, unterschiedlich sein.")]), _vm._v(" "), _c('p', [_vm._v("Ich weiß nicht, wer Sie sind, aber ich bin mir sicher, dass Sie es von vielen Menschen nicht sind.")]), _vm._v(" "), _c('p', [_vm._v("Sie sind NICHT: Nick the Greek, Ken Uston oder ein anderer berühmter Glücksspieler.")]), _vm._v(" "), _c('p', [_vm._v("Ich gehe davon aus, dass Sie ein ernsthaftes Interesse an Glücksspielen haben, aber noch kein Experte sind.")]), _vm._v(" "), _c('p', [_vm._v("Kommen wir also zur wichtigsten Frage überhaupt.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0